import { render, staticRenderFns } from "./searchCategory.vue?vue&type=template&id=07422f4c&scoped=true&"
import script from "./searchCategory.vue?vue&type=script&lang=js&"
export * from "./searchCategory.vue?vue&type=script&lang=js&"
import style0 from "./searchCategory.vue?vue&type=style&index=0&id=07422f4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07422f4c",
  null
  
)

export default component.exports